import Loading from './loading'
export default {
    install (Vue) {
        console.log(Vue)
        Vue.directive('Loading', Loading)
    }
}
